import { render, staticRenderFns } from "./SimpleWitget.vue?vue&type=template&id=5ba02256&scoped=true"
import script from "./SimpleWitget.ts?vue&type=script&lang=ts&external"
export * from "./SimpleWitget.ts?vue&type=script&lang=ts&external"
import style0 from "./SimpleWitget.vue?vue&type=style&index=0&id=5ba02256&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba02256",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ba02256')) {
      api.createRecord('5ba02256', component.options)
    } else {
      api.reload('5ba02256', component.options)
    }
    module.hot.accept("./SimpleWitget.vue?vue&type=template&id=5ba02256&scoped=true", function () {
      api.rerender('5ba02256', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Dashboard/components/ProcessesSection/SimpleWitget/SimpleWitget.vue"
export default component.exports